import { Button, styled, Paper } from '@mui/material';

// const DRAWER_WIDTH = '18rem';

export const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  ...theme.typography.body2,
  textAlign: 'center',
  color: theme.palette.text.secondary,
  height: '12rem',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  padding: '1.25rem',
  '&:hover': {
    transform: 'scale(1.05)',
    cursor: 'pointer',
  },
}));

export const DashboardButton = styled(Button)(({ theme }) => ({
  width: '100%',
  size: 'small',
  textTransform: 'none',
  pointerEvents: 'none',
  color: theme.palette.text.primary,
  marginTop: '0.6rem',
}));

export const DisabledButton = styled(DashboardButton)(({ theme }) => ({
  disabled: 'true',
  background: theme.palette.action.disabledBackground,
  color: theme.palette.text.disabled,
  padding: 0,
  marginTop: 0,
  height: '100%',
}));

export const DashboardContainer = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  flex: '1 0 auto',
  minHeight: '100%',
  width: '100%',
  maxWidth: '100%',
  boxSizing: 'border-box',
  alignItems: 'stretch',
}));

export const MainContainer = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
}));

export const DashboardContent = styled('div')(() => ({
  width: '100%',
  marginLeft: 'auto',
  marginRight: 'auto',
  display: 'flex',
  padding: '3rem',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  marginTop: 'auto',
  placeItems: 'center',
}));

export const ImageContainer = styled('div')(() => ({
  userSelect: 'none',
  display: 'flex',
  flexDirection: 'column',
  paddingTop: '1rem',
  alignItems: 'center',
  '& h3': {
    background: 'linear-gradient(to right, #009fff, #ec2f4b)',
    letterSpacing: '0.3rem',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
  },
  '& img': {
    width: '4rem',
  },
}));

export const Disclaimer = styled('footer')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: theme.spacing(1.5),
  boxSizing: 'border-box',
  flexShrink: 0,
  marginTop: 'auto',
  marginLeft: 'calc(var(--page-gutter, 0px) * -1)',
  marginRight: 'calc(var(--page-gutter, 0px) * -1)',
  marginBottom: 'calc(var(--page-gutter, 0px) * -1)',
  width: 'calc(100% + 2 * var(--page-gutter, 0px))',
  maxWidth: 'none',
  padding: theme.spacing(2),
  borderTop: `1px solid ${theme.palette.divider}`,
  backgroundColor: theme.palette.background.paper,
  color: theme.palette.text.secondary,
  textAlign: 'left',
  [theme.breakpoints.up('sm')]: {
    padding: theme.spacing(2, 3),
  },
  [theme.breakpoints.up('md')]: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: theme.spacing(3),
    padding: theme.spacing(2.5, 4),
  },
}));
